<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <div class="row" *ngFor="let educationControl of getControls('education'); let i = index;">
    <div class="col-xs-12 col-md-6 form-group">
      <div formArrayName="education">
        <label for="education{{i}}" class="zaya-form-sub-header" i18n="label|Practitioner education experience.@@labelEducation" *ngIf="i === 0">University/Institute/School</label>
        <div class="input-group">
          <input id="education{{i}}" type="text" class="form-control" [formControlName]="i">
        </div>
        <span
          class="help-block"
          *ngIf="i == 0 && formGroup.get('education.0').invalid && formGroup.get('education.0').touched"
          i18n="error message|The message shown when education has not been entered.@@errorEducation">
            Please enter at least 1 university/institute/school.
        </span>
      </div>
    </div>
    <div class="col-xs-12 col-md-6 form-group">
      <div formArrayName="degree">
        <label for="degree{{i}}" class="zaya-form-sub-header" i18n="label|Practitioner educational degree.@@labelDegree" *ngIf="i === 0">Degree</label>
        <div class="input-group">
          <input id="degree{{i}}" type="text" class="form-control" [formControlName]="i">
        </div>
        <span
          class="help-block"
          *ngIf="i == 0 && formGroup.get('degree.' + i).invalid && formGroup.get('degree.' + i).touched"
          i18n="error message|The message shown when degree has not been entered.@@errorDegree">
            Please enter a valid degree.
        </span>
        <div class="text-right" *ngIf="i > 0">
          <span
            class="zaya-form-link"
            (click)="onRemoveControl('education', i);
            onRemoveControl('degree', i);">
            x <ng-container i18n="button|Used to remove an education a user has entered.@@buttonRemoveEducation">Remove this university/institute/school</ng-container>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center" style="margin-bottom: 10px;">
    <span
      class="zaya-form-link"
      (click)="onAddControl('education');
      onAddControl('degree')">
      + <ng-container i18n="button|Used to add an education.@@buttonAddEducation">Add another university/institute/school</ng-container>
    </span>
  </div>

  <div class="row" *ngFor="let licenseControl of getControls('licenses'); let i = index;">
    <div class="col-xs-12 col-md-6 form-group">
      <div formArrayName="licenses">
        <label for="license{{i}}" class="zaya-form-sub-header" i18n="label|Practitioner training.@@labelTraining" *ngIf="i === 0">Training/Experience</label>
        <div class="input-group">
          <input id="license{{i}}" type="text" class="form-control" [formControlName]="i">
        </div>
        <span
          class="help-block"
          *ngIf="i == 0 && formGroup.get('licenses.0').invalid && formGroup.get('licenses.0').touched"
          i18n="error message|The message shown when training has not been entered.@@errorTraining">
            Please enter at least 1 training/experience.
        </span>
        <div class="text-right" *ngIf="i > 0">
          <span class="zaya-form-link" (click)="onRemoveControl('licenses', i);">
            x <ng-container i18n="button|Used to remove a license a user has entered.@@buttonRemoveTraining">Remove this training/experience</ng-container>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center" style="margin-bottom: 10px;">
    <span class="zaya-form-link" (click)="onAddControl('licenses');">
      + <ng-container i18n="button|Used to add a license.@@buttonAddTraining">Add another training/experience</ng-container>
    </span>
  </div>

  <div class="row" *ngFor="let languageControl of getControls('languages'); let i = index;">
    <div class="col-xs-12 col-md-6 form-group">
      <div formArrayName="languages">
        <label for="language{{i}}" class="zaya-form-sub-header" i18n="label|The language a practitioner speaks.@@labelLanguage" *ngIf="i === 0">Language</label>
        <select id="language{{i}}" class="form-control" [formControlName]="i">
          <option *ngFor="let language of _filterLanguages(i)" [value]="language" i18n="label|Options used for selecting a language.@@labelLanguageOptions">
            {language, select, Select... {Select...} English {English} German {German} Arabic {Arabic} Spanish {Spanish} French {French} Chinese {Chinese} Portuguese {Portuguese} Russian {Russian} Turkish {Turkish} Hindi {Hindi} Vietnamese {Vietnamese}}
          </option>
        </select>
        <span
          class="help-block"
          *ngIf="i == 0 && formGroup.get('languages.0').invalid && formGroup.get('languages.0').touched"
          i18n="error message|The message shown when language has not been entered.@@errorLanguage">
            Please enter at least 1 language.
        </span>
        <div class="text-right" *ngIf="i > 0">
          <span class="zaya-form-link" (click)="onRemoveControl('languages', i);">
            x <ng-container i18n="button|Used to remove a language a user has entered.@@buttonRemoveLanguage">Remove this language</ng-container>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center" style="margin-bottom: 30px;">
    <span class="zaya-form-link" (click)="onAddControl('languages');">
      + <ng-container i18n="button|Used to add a language.@@buttonAddLanguage">Add another language</ng-container>
    </span>
  </div>


  <div class="row" *ngFor="let _ of getControls('professionalBodies'); let i = index;">
    <div class="col-xs-12 col-md-6 form-group">
      <div formArrayName="professionalBodies">
        <label for="professionalBody{{i}}" class="zaya-form-sub-header" i18n="label|The professional body a practitioner practices.@@labelProfessionalBody" *ngIf="i === 0">Professional body you belong to</label>
        <select class="form-control" (change)="updateProfessionalBody(i, $event.target.value)" id="professionalBodySelect{{i}}">
          <option *ngFor="let professionalBody of professionalBodies" [value]="professionalBody">
            {{professionalBody}}
          </option>
        </select>
        <div class="text-right" *ngIf="i > 0">
          <span class="zaya-form-link" (click)="onRemoveControl('professionalBodies', i);">
            x <ng-container i18n="button|Used to remove a professional body a user has entered.@@buttonRemoveProfessionalBody">Remove this professional body</ng-container>
          </span>
        </div>
        <input id="professionalBody{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
      </div>
    </div>
  </div>

  <div class="text-center" style="margin-bottom: 30px;">
    <span class="zaya-form-link" (click)="onAddControl('professionalBodies');">
      + <ng-container i18n="button|Used to add a professional body.@@buttonAddProfessionalBody">Add another professional body</ng-container>
    </span>
  </div>

  <div formArrayName="accreditedRegisters">
    <div class="row" *ngFor="let _ of getControls('accreditedRegisters'); let i = index;">
      <div class="col-xs-12 col-md-6 form-group">
        <label for="accreditedRegister{{i}}" class="zaya-form-sub-header" i18n="label|The accredited register a practitioner practices.@@labelAccreditedRegister" *ngIf="i === 0">Accredited register membership</label>
        <select class="form-control" (change)="updateAccreditedRegister(i, $event.target.value)" id="accreditedRegisterSelect{{i}}">
          <option *ngFor="let accreditedRegister of accreditedRegisters" [value]="accreditedRegister">
            {{accreditedRegister}}
          </option>
        </select>
        <div class="text-right" *ngIf="i > 0">
          <span class="zaya-form-link" (click)="onRemoveControl('accreditedRegisters', i);">
            x <ng-container i18n="button|Used to remove an accredited register a user has entered.@@buttonRemoveAccreditedRegister">Remove this accredited register membership</ng-container>
          </span>
        </div>
        <input id="accreditedRegister{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
      </div>
    </div>
  </div>

  <div class="text-center" style="margin-bottom: 30px;">
    <span class="zaya-form-link" (click)="onAddControl('accreditedRegisters');">
      + <ng-container i18n="button|Used to add an accredited register.@@buttonAddProfessionalBody">Add another accredited register membership</ng-container>
    </span>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!formGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>
</form>
